import { useState, useEffect } from 'react';
import { isServer } from '@anton.bobrov/react-hooks';

function useLsBoolState(value, name) {
  const getLsValue = () => {
    if (isServer) {
      return value;
    }
    if (!localStorage.getItem(name)) {
      return value;
    }
    const isTrue2 = localStorage.getItem(name) === "true";
    return isTrue2 ?? value;
  };
  const [isTrue, setIsTrue] = useState(getLsValue());
  useEffect(() => {
    localStorage.setItem(name, String(isTrue));
  }, [isTrue, name]);
  return [isTrue, setIsTrue];
}

export { useLsBoolState };
//# sourceMappingURL=useLsBoolState.js.map
